import React from 'react';
import { Image } from 'views/components/atoms/Image';
import styled from '@emotion/styled';
import { Color, FontSize, MAX_WIDTH } from 'views/constants';
import { Spacer } from 'views/components/atoms/Spacer';
import { Typography } from 'views/components/atoms/Typography';
import { Icon } from 'views/components/molecules/Icon';
import { Panel } from 'views/components/molecules/Panel';
import iconImage from 'views/layouts/ConfigurationProfilePageLayout/images/icon.png';
import installProfileImage from 'views/layouts/ConfigurationProfilePageLayout/images/install_profile.png';
import installYourAppImage from 'views/layouts/ConfigurationProfilePageLayout/images/install_yourapp.png';
import { FormattedMessage, useIntl } from 'react-intl';
import { localeIds } from 'locals';
import { LinkButton } from 'views/components/molecules/LinkButton';

const Wrapper = styled.div`
  padding: 40px 20px;
`;

const LogoIconWrapper = styled.div`
  margin: auto;
  width: 120px;
  height: 120px;
`;

const UdidHelpWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: baseline;
`;

const IconWrapper = styled.div`
  flex: none;
`;

const ButtonWrapper = styled.div`
  max-width: ${MAX_WIDTH};
  margin: auto;
`;

type ConfigurationProfilePageLayoutProps = {
  installUrl: string;
  onInstall(): void;
  disabledInstallButton?: boolean;
};

export const ConfigurationProfilePageLayout: React.FC<
  ConfigurationProfilePageLayoutProps
> = ({ installUrl, onInstall, disabledInstallButton }) => {
  const intl = useIntl();
  return (
    <Wrapper>
      <LogoIconWrapper>
        <Image src={iconImage} />
      </LogoIconWrapper>

      <Spacer size="large" />

      <Typography size={FontSize.XXL} bold block>
        <FormattedMessage
          id={localeIds.configurationProfilePageLayout.deploygate}
        />
      </Typography>

      <Spacer />

      <Typography block color={Color.C3}>
        <FormattedMessage id={localeIds.configurationProfilePageLayout.help} />
      </Typography>

      <Spacer size="large" />

      <UdidHelpWrapper>
        <IconWrapper>
          <Icon type="info" size="small" />
        </IconWrapper>
        <Typography block color={Color.C3} size={FontSize.S}>
          <FormattedMessage
            id={localeIds.configurationProfilePageLayout.udidHelp}
          />
        </Typography>
      </UdidHelpWrapper>

      <Spacer />

      <ButtonWrapper>
        <LinkButton
          label={
            <FormattedMessage
              id={localeIds.configurationProfilePageLayout.install}
            />
          }
          style="primary"
          to={installUrl}
          onClick={onInstall}
          disabled={disabledInstallButton}
          anotherTab={true}
        />
      </ButtonWrapper>

      <Spacer />

      <Typography block color={Color.C3} size={FontSize.S}>
        <FormattedMessage
          id={localeIds.configurationProfilePageLayout.installNotice}
        />
      </Typography>

      <Spacer />

      <Panel
        text={intl.formatMessage({
          id: localeIds.configurationProfilePageLayout.guide1,
        })}
        image={{
          srcElement: <Image src={installProfileImage} />,
          width: '287px',
        }}
      />

      <Spacer />

      <Panel
        text={intl.formatMessage({
          id: localeIds.configurationProfilePageLayout.guide2,
        })}
        image={{
          srcElement: <Image src={installYourAppImage} />,
          width: '287px',
        }}
      />
    </Wrapper>
  );
};
